<template>
  <div class="summary-table">
    <div class="header">
      <div class="title">
        <h2>Total Rate</h2>
        <div class="label"><button @click="targetInfoOpen = !targetInfoOpen"><span class="sr-only">mix target information</span></button>Target is {{ target }}%</div>
      </div>
      <div class="value">{{ sum }}%</div>
      <div class="value">{{ this.$store.state.totals.lbsPerAcre }} <small>lbs/acre</small></div>
      <div v-show="targetInfoOpen" id="target-info">
        Since you picked <strong>{{ this.$store.state.plantingMethods[this.$store.state.formData.plantingMethod] }}</strong> as your planting method, try to create a mix with components that add up to <strong>{{ target }}%</strong> of the full seeding rate.
      </div>
    </div>
    <div class="body" v-if="this.$store.state.formData.selectedCrops.length">
      <table>
        <thead>
          <tr>
            <th>Species</th>
            <th>% full rate</th>
            <th>lbs/acre</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(entry, index) in this.$store.state.formData.selectedCrops" :key="index" >
            <td class="name">
              <button v-if="canEdit" class="edit" @click="$emit('edit', entry)"><span class="text">{{ entry.crop.species }}</span></button>
              <span v-else class="text">{{ entry.crop.species }}</span>
            </td>
            <td class="value text">{{ entry.amount / entry.crop.seedingRate * 100 }}</td>
            <td class="value"><span class="text">{{ entry.amount }}</span> <button v-if="canEdit" class="remove" @click.stop="$emit('remove', entry.crop)"><span class="sr-only">remove</span></button></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: ['sum', 'target', 'canEdit'],
  data () {
    return {
      targetInfoOpen: false
    }
  }
}
</script>

<style lang="scss">
  .summary-table{
    .header{
      padding: 0 15px 15px;
      border-bottom: solid 1px rgba($color-black, .15);
      display: flex;
      flex-wrap: wrap;
      @include media-breakpoint-up(lg){
        padding: 0 30px 15px;
      }
      .title{
        width: 50%;
        h2{
          margin-bottom: 0;
          font-weight: 600;
        }
        .label{
          font-size: 14px;
          font-weight: 600;
          text-transform: uppercase;
          color: $color-neon-green;
          letter-spacing: 1px;
        }
      }
      .label{
        font-size: 12px;
        color: $color-dark-green;
        display: flex;
        align-items: center;
        font-weight: 600;
        button{
          @include resetButton;
          width: 16px;
          height: 16px;
          background: url('/assets/alert.svg') no-repeat center center;
          display: inline-block;
          margin-right: 6px;
          &:focus{
            outline: none;
          }
        }
      }
      .value{
        width: 25%;
        font-weight: 600;
        line-height: 36px;
        small{
          letter-spacing: 0;
        }
      }
    }
    #target-info{
      width: 100%;
      font-size: 14px;
      font-weight: 400;
      strong{
        font-weight: 600;
      }
    }
    .body{
      padding: 20px 15px 15px;
      max-height: 30vh;
      overflow: scroll;
      -webkit-overflow-scrolling: touch;
      @include media-breakpoint-up(lg){
        padding: 20px 30px 15px;
      }
      table{
        width: 100%;
        th{
          font-weight: 600;
          font-size: 13px;
        }
        tr:hover{
          .remove{
            opacity: 1;
          }
        }
        td{
          font-weight: normal;
          padding: 10px 0;
          @include media-breakpoint-up(lg){
            padding: 6px 0;
          }
          &.name{
            width: 50%;
          }
          &.value{
            width: 25%;
          }
        }
        button{
          @include resetButton;
          color: $color-dark-green;
          text-align: left;
          &.edit{
            padding-left: 22px;
            background: url('/assets/pencil.svg') no-repeat left 2px;
            background-size: 16px auto;
          }
          &.remove{
            width: 20px;
            height: 20px;
            border-radius: 3px;
            box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
            padding: 0;
            float: right;
            background: #FFF url('/assets/close-green.svg') no-repeat center 6px;
            background-size: 10px auto;
            border-color: #FFF;
            @include media-breakpoint-up(lg){
              opacity: 0;
              transition: .2s;
            }
          }
          @include media-breakpoint-up(lg){
            &:hover{
              .text{
                opacity: 1;
              }
            }
          }
        }
      }
      .text{
        transition: .2s;
        opacity: .7;
      }
    }
  }
</style>
